import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-modal-pesquisa-lista',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-pesquisa-lista.component.html',
  styleUrls: ['./modal-pesquisa-lista.component.css']
})
export class ModalPesquisaListaComponent {
  @Input() aberta = false;
  @Input() titulo = 'Pesquisar';
  @Input() termo = '';
  @Input() nomeCampo = 'buscaModal';
  @Input() placeholder = 'Digite para pesquisar';
  @Input() mensagemVazia = 'Nenhum registro encontrado.';
  @Input() itens: unknown[] = [];
  @Input() rotuloItem: (item: unknown) => string = () => '';
  @Input() detalheItem: (item: unknown) => string = () => '';

  @Output() termoChange = new EventEmitter<string>();
  @Output() selecionar = new EventEmitter<unknown>();
  @Output() limpar = new EventEmitter<void>();
  @Output() fechar = new EventEmitter<void>();
}
